var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Grid = function() {
    EHDI.aka.Container.call(this);
};

EHDI.game.Grid.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Grid.prototype.init = function () {
  this._gridBase;
  this._gridTiles = [];
  this._shuffle = false;
    this._isClear = false;
  this._deltaDelay = 0;
  this._currentDelta = 0;
  this._shufflePattern;

  this._shuffleCount;
  this._shuffleCurrentCount = 0;
  this._gridOff = true;

  if (this._gridBase == null) {
    this._gridBase = new EHDI.aka.Sprite(EHDI.Assets.images["grid_base"]);
    this._gridBase.anchor.set(0.5,0.5);

    this.addChild(this._gridBase);
  }

  for (var i = 0; i<9; i++) {
    var j = i%3;
    var k = Math.floor(i/3);
    var tileGrid;

    var scorecount;

    if (i == 0 || i == 7) {
      scorecount = 10;
    } else if (i == 6 || i == 5) {
      scorecount = 20;
    } else if (i == 3 || i==2) {
      scorecount = 30;
    } else if (i == 1 || i==8) {
      scorecount = 40;
    } else {
      scorecount = 50;
    }

    tileGrid =  new EHDI.game.GridTile();

    if (j == 0) {
      tileGrid.init(EHDI.game.GridTileTipe.LEFT, scorecount);
      tileGrid.x = -110;
    } else if (j == 1) {
      tileGrid.init(EHDI.game.GridTileTipe.CENTER, scorecount);
    } else {
      tileGrid.init(EHDI.game.GridTileTipe.RIGHT, scorecount);
      tileGrid.x = 110;
    }

    if (k == 0) {
      tileGrid.y = -84;
      tileGrid.scale.set(0.9,0.9);

      if (j == 0) {
        tileGrid.x += 10;
      } else if (j == 2) {
        tileGrid.x -= 10;
      }

    } else if (k == 1) {
      tileGrid.y = -4;
      tileGrid.scale.set(0.95,0.95);

      if (j == 0) {
        tileGrid.x += 5;
      } else if (j == 2) {
        tileGrid.x -= 5;
      }
    } else {
      tileGrid.y = 76;
    }

    tileGrid.changeAsset(2);

    this.addChild(tileGrid);
    this._gridTiles.push(tileGrid);

  }
}

EHDI.game.Grid.prototype.shuffle = function(isClear) {
  this._shufflePattern = [[0,1,2],
                          [3,4,5],
                          [6,7,8],
                          [0,3,6],
                          [1,4,7],
                          [2,5,8],
                          [0,4,8],
                          [6,4,2]];

  EHDI.GAME.soundManager.playSFX("pattern");

  this._currentDelta = 0;

  this._shuffleCount = this._shufflePattern.length;
  this._shuffleCurrentCount = 0;
  this._gridOff = false;

  this._shuffle = true;
  this._isClear = isClear;
}

EHDI.game.Grid.prototype.getGridtilePos = function(count) {
  return this._gridTiles[count].position;
}

EHDI.game.Grid.prototype.checkTileCount = function(count) {
  if (this._pattern != null && this._pattern.indexOf(count) != -1) {
    return true;
  } else {
    return false;
  }
}

EHDI.game.Grid.prototype.closeTileGrid = function(count) {
  this._gridTiles[count].changeAsset(0);
  this._pattern.splice(this._pattern.indexOf(count), 1);
}

EHDI.game.Grid.prototype.checkPatternCount = function() {
  return this._pattern.length;
}

EHDI.game.Grid.prototype.update = function(delta) {
  if(this._shuffle) {
    this._currentDelta += delta;
    if (this._currentDelta >= this._deltaDelay) {
      if (this._gridOff) {
        var randomIndex = Math.floor(Math.random() * this._shufflePattern.length);
        this._pattern = this._shufflePattern[randomIndex];
        this._shufflePattern.splice(randomIndex, 1);
        this._shuffleCurrentCount ++;
        if(this._isClear)
            this.emit('SHUFFLE_DURING');
        for (var i = 0; i < this._gridTiles.length; i++) {
          if (this._pattern.indexOf(i) != -1) {
            this._gridTiles[i].changeAsset(1);
            this._gridTiles[i].addGlow();
          } else {
            this._gridTiles[i].changeAsset(0);
            this._gridTiles[i].removeGlow();
          }
        }
        this._gridOff = false;
      } else {
        for (var i = 0; i < this._gridTiles.length; i++) {
          this._gridTiles[i].changeAsset(2);
          this._gridTiles[i].removeGlow();
        }
        this._gridOff = true;
      }



      if (this._shuffleCurrentCount >= this._shuffleCount) {
        this._shuffle = false;
        this.emit('SHUFFLE_FINISHED');
      } else {
        this._currentDelta -= this._deltaDelay;
        if (this._gridOff)
          this._deltaDelay = 200;
        else {
          this._deltaDelay = 200;
        }
      }
    }
  }
}
